import React, { Component } from 'react';
import { MediaStatusTypes, ModalTypes } from '../../Constants';
import Media from '../../components/CommonSet/Media';
import SummaryStyles from './Summary.cssmodule.less';
import classNames from 'classnames';

class CurriculumQuiz extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            isOpen: false,
        };
        this.answerPopup = new entrylms.Modal();
        this.openAnswer = this.openAnswer.bind(this);
    }

    setIndex(n) {
        const max = this.props.data.contents.length - 1;
        const index = Math.max(0, n);
        return this.setState({ index: Math.min(index, max) });
    }

    openAnswer() {
        const content = this.props.data.contents[this.state.index];
        this.answerPopup.modalData = {
            type: ModalTypes.CURRICULUM_ANSWER,
            content,
        };
        this.answerPopup.itemIndex = 0;
        this.answerPopup.show();
    }

    handleButtonClick(event, action) {
        entrylms.emit(action, { category: 'curriculum' }, null);
    }

    createMediaView(media = {}) {
        const { category } = media;
        if (category && category !== MediaStatusTypes.NONE) {
            return <Media className={classNames(SummaryStyles[category], SummaryStyles.media)} media={media} option={{ width: 504, height: 260 }}/>;
        }
        return null;
    }

    render() {
        const { contents = {} } = this.props.data;
        const { index } = this.state;
        const lastIndex = contents.length - 1;
        const content = contents[index];
        if(!content) {
            return ;
        }
        const { questions, media } = content;
        return (
            <div className={SummaryStyles.curriculum}>
                {/* 스텝박스 영역 - 학습시작 / 학습목표에는 내용기술 안함. */}
                <div className={SummaryStyles.intro_top}>
                    <div className={SummaryStyles.intro_inner}>
                        {/* 느낌표 일때 exclamation 클래스 / 물음표 일때 question 클래스 */}
                        <div className={classNames(SummaryStyles.cell, SummaryStyles.exclamation)}>
                            <div className={SummaryStyles.thmb_group}>
                                <strong className={SummaryStyles.title}>확인문제</strong>
                                <span className={SummaryStyles.thmb}>&nbsp;</span>
                            </div>
                            확인 문제를 통해 배운 내용을 점검해 봅시다.
                        </div>
                    </div>
                </div>
                <div className={SummaryStyles.body}>
                    <div className={SummaryStyles.summary_box}>
                        <strong className={SummaryStyles.sjt}>
                            {questions}
                            <span className={SummaryStyles.step}>{index + 1}/{lastIndex + 1}</span>
                        </strong>
                        <div className={SummaryStyles.thmb_box}>
                            {this.createMediaView(media)}
                        </div>
                        <span
                            className={classNames(SummaryStyles.scroll_btn, SummaryStyles.prev, { [SummaryStyles.disabled]: index === 0 })}
                            onClick={() => this.setIndex(index - 1)}>
                            이전
                        </span>
                        <span
                            className={classNames(SummaryStyles.scroll_btn, SummaryStyles.next, { [SummaryStyles.disabled]: index === lastIndex })}
                            onClick={() => this.setIndex(index + 1)}>
                            다음
                        </span>
                        <span className={SummaryStyles.result_btn} onClick={this.openAnswer}>정답 확인</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default CurriculumQuiz;



// WEBPACK FOOTER //
// ./components/Curriculum/Quiz.js